//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    ecuPackage: Object
  },
  computed: {
    classFromIntegration () {
      switch (this.ecuPackage.IntegrationType) {
        case 'Vehicle Custom ECU':
          return 'auto_integration_custom_vehicle'
        case 'Engine Custom ECU':
          return 'auto_integration_custom_engine'
        case 'Engine Tuning Base ECU':
          return 'auto_integration_tuning_base'
        case 'Engine GP ECU':
          return 'auto_integration_gp'
        case 'Contact For Details':
          return 'auto_integration_contact'
        default:
          // If we don't know, we'll call it a plug-in
          return 'auto_integration_plug_in'
      }
    }
  }
}
